import ApiService from "../../Services/ApiService";

export default {
    state: {
        txOrders: []
    },
    getters: {
        getTxOrders(state) {
            return state.txOrders;
        },
    },
    mutations: {
        setTxOrders(state, payload) {
            state.txOrders = payload;
        },
    },
    actions: {
        async loadTxOrders({ commit }, user_account_id) {
            const responseTxOrders = (await ApiService.getTxOrders(user_account_id)).data;

            commit("setTxOrders", responseTxOrders);
        },
        async insertTxOrder({ commit }, order) {
            await ApiService.insertTxOrder(order);

            const responseTxOrders = (await ApiService.getTxOrders(order.user_account_id)).data;

            commit("setTxOrders", responseTxOrders);
        },
        async deleteTxOrder({ commit }, data) {
            const user_account_id = data.user_account_id;

            await ApiService.deleteTxOrder(data);

            const responseTxOrders = (await ApiService.getTxOrders(user_account_id)).data;

            commit("setTxOrders", responseTxOrders);
        }
    }
};
